import {createSelector} from "reselect";

const GeneralSettings = (state) => state.generalSettings || {};

const General = (state) => state.general || {};

export const getNotifyError = createSelector(General, (data) => data?.notifyError);

export const getOrganization = createSelector(
  General,
  (data) => data?.organization || {}
);

export const getOrgAddress = createSelector(
  General,
  (data) => data?.organizationAddress || {}
);

export const modal = createSelector(GeneralSettings, (general) => general.modal);

export const modalCallback = createSelector(
  GeneralSettings,
  (general) => general.onConfirmCallback
);

export const getScope = createSelector(GeneralSettings, (data) => data.scope || []);

export const getControllersForScope = createSelector(
  GeneralSettings,
  (data) => data.controllersForScope || []
);
